// extracted by css-extract-rspack-plugin
export default {"Octicon":"blankslate-error-message-module__Octicon__sf2aKTi","Text":"blankslate-error-message-module__Text__NHoyjR2"};